import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from 'components/common/PageHeader';

const ProcessTimeLine = ({ dadosProcesso, operacao }) => {
  return (
    <>
      <PageHeader title={``} titleTag="h5">
        {dadosProcesso.map(row => {
          return (
            <>
              <div>
                <div id="process">
                  <ul id="stepButtons" className="process-row nav nav-tabs">
                    {row.DT_ABERTURA !== null &&
                      row.DT_ABERTURA !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                          >
                            <i className="fa fa-info" height="90" />
                          </button>
                          <p>
                            ABERTURA DE PROCESSO<small>{row.DT_ABERTURA}</small>
                          </p>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step1"
                          >
                            <i className="fa fa-info fa-3x"></i>
                          </button>
                          <p>
                            ABERTURA DE PROCESSO<small></small>
                          </p>
                        </li>
                      </>
                    )}
                    {row.PREV_EMBARQUE !== null &&
                      row.PREV_EMBARQUE !== '00/00/0000' &&
                      row.CONF_EMBARQUE === null ? (
                      <>
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step2"
                          >
                            <i className="fa fa-truck-plane fa-3x"></i>
                          </button>
                          <p>
                            EMBARQUE
                            <small>Prev. {row.PREV_EMBARQUE}</small>
                          </p>
                        </li>
                      </>
                    ) : row.CONF_EMBARQUE !== null &&
                      row.CONF_EMBARQUE !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step3"
                          >
                            <i className="fa fa-truck-plane fa-3x"></i>
                          </button>
                          <p>
                            EMBARQUE<small>{row.CONF_EMBARQUE}</small>
                          </p>
                        </li>
                      </>
                    )
                      :
                      (
                        <>
                          <li className="process-step">
                            <button
                              type="button"
                              className="btn btn-circle btn-default"
                              data-toggle="tab"
                              href="#step3"
                            >
                              <i className="fa fa-truck-plane fa-3x"></i>
                            </button>
                            <p>
                              EMBARQUE<small></small>
                            </p>
                          </li>
                        </>
                      )}
                    {row.PREV_CHEGADA !== null &&
                      row.PREV_CHEGADA !== '00/00/0000' &&
                      row.CONF_CHEGADA === null ? (
                      <>
                        <li className="process-step ">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step4"
                          >
                            <i className="fa fa-calendar-day fa-3x"></i>
                          </button>
                          <p>
                            CHEGADA<small>Prev. {row.PREV_CHEGADA}</small>
                          </p>
                        </li>
                      </>
                    ) : row.CONF_CHEGADA !== null ? (
                      <li className="process-step active">
                        <button
                          type="button"
                          className="btn btn-circle btn-default"
                          data-toggle="tab"
                          href="#step4"
                        >
                          <i className="fa fa-calendar-day fa-3x"></i>
                        </button>
                        <p>
                          CHEGADA<small>{row.CONF_CHEGADA}</small>
                        </p>
                      </li>
                    )
                      :
                      (
                        <li className="process-step ">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step4"
                          >
                            <i className="fa fa-calendar-day fa-3x"></i>
                          </button>
                          <p>
                            CHEGADA<small>{row.PREV_CHEGADA}</small>
                          </p>
                        </li>
                      )}
                   
                    {operacao === 'E' ?
                      <>
                        {row.DT_AVERBACAO !== null &&
                          row.DT_AVERBACAO !== '00/00/0000' ? (
                          <>
                            <li className="process-step active">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-file-pen"></i>
                              </button>
                              <p>
                                {operacao === "E" ? "AVERBAÇÃO" : "REGISTRO D.I."}
                                <small>{row.DT_AVERBACAO}</small>
                              </p>
                            </li>
                          </>
                        ) : (
                          <>
                            <li className="process-step ">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-file-pen fa-3x"></i>
                              </button>
                              <p>
                                {operacao === "E" ? "AVERBAÇÃO" : "REGISTRO D.I."}
                                <small></small>
                              </p>
                            </li>
                          </>
                        )}
                      </>
                      :
                      <>
                        {row.DT_DI_REGISTRO !== null &&
                          row.DT_DI_REGISTRO !== '00/00/0000' ? (
                          <>
                            <li className="process-step active">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-file-pen"></i>
                              </button>
                              <p>
                                AVERBAÇÃO
                                <small>{row.DT_DI_REGISTRO}</small>
                              </p>
                            </li>
                          </>
                        ) : (
                          <>
                            <li className="process-step ">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-file-pen fa-3x"></i>
                              </button>
                              <p>
                                AVERBAÇÃO
                                <small></small>
                              </p>
                            </li>
                          </>
                        )}
                      </>}
                    {operacao !== "E" ?
                      <>
                        {row.CANAL !== 'null' && row.CANAL !== null ? (
                          <>
                            <li className="process-step active">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-receipt fa-3x"></i>
                              </button>
                              <p>
                                PARAMETRIZAÇÃO<small>{row.CANAL}</small>
                              </p>
                            </li>
                          </>
                        ) : (
                          <>
                            <li className="process-step">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-receipt fa-3x"></i>
                              </button>
                              <p>
                                PARAMETRIZAÇÃO<small></small>
                              </p>
                            </li>
                          </>
                        )}
                        {row.DT_DESEMBARACO !== null &&
                          row.DT_DESEMBARACO !== '00/00/0000' ? (
                          <>
                            <li className="process-step active">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-clipboard-check fa-3x"></i>
                              </button>
                              <p>
                                DESEMBARAÇO<small>{row.DT_DESEMBARACO}</small>
                              </p>
                            </li>
                          </>
                        ) : (
                          <>
                            <li className="process-step">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-clipboard-check fa-3x"></i>
                              </button>
                              <p>
                                DESEMBARAÇO<small></small>
                              </p>
                            </li>
                          </>
                        )}
                        {row.DT_CARREGAMENTO !== null &&
                          row.DT_CARREGAMENTO !== '00/00/0000' ? (
                          <>
                            <li className="process-step active">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-truck" size="lg"></i>
                              </button>
                              <p>
                                CARREGAMENTO<small>{row.DT_CARREGAMENTO}</small>
                              </p>
                            </li>
                          </>
                        ) : (
                          <>
                            <li className="process-step">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-truck fa-3x"></i>
                              </button>
                              <p>
                                CARREGAMENTO<small></small>
                              </p>
                            </li>
                          </>
                        )}

                        {row.DT_FATURAMENTO !== null &&
                          row.DT_FATURAMENTO !== '00/00/0000' ? (
                          <>
                            <li className="process-step active">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-file-invoice fa-3x"></i>
                              </button>
                              <p>
                                FATURAMENTO<small>{row.DT_FATURAMENTO}</small>
                              </p>
                            </li>
                          </>
                        ) : (
                          <>
                            <li className="process-step">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-file-invoice fa-3x"></i>
                              </button>
                              <p>
                                FATURAMENTO<small></small>
                              </p>
                            </li>
                          </>
                        )}
                      </> :
                      <>
                        {row.CONF_EMBARQUE !== null &&
                          row.CONF_EMBARQUE !== '00/00/0000' ? (
                          <>
                            <li className="process-step active">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step3"
                              >
                                <i className="fa fa-truck-plane fa-3x"></i>
                              </button>
                              <p>
                                TRANSBORDO/CONEXÃO<small>{row.CONF_EMBARQUE}</small>
                              </p>
                            </li>
                          </>
                        ) : (
                          <>
                            <li className="process-step">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step3"
                              >
                                <i className="fa fa-truck-plane fa-3x"></i>
                              </button>
                              <p>
                                TRANSBORDO/CONEXÃO<small></small>
                              </p>
                            </li>
                          </>
                        )}
                        {row.CONF_CHEGADA !== null &&
                          row.CONF_CHEGADA !== '00/00/0000' ? (
                          <>
                            <li className="process-step active">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-calendar-check fa-3x"></i>
                              </button>
                              <p>
                                CHEGADA<small>{row.CONF_CHEGADA}</small>
                              </p>
                            </li>
                          </>
                        ) : (
                          <>
                            <li className="process-step">
                              <button
                                type="button"
                                className="btn btn-circle btn-default"
                                data-toggle="tab"
                                href="#step4"
                              >
                                <i className="fa fa-calendar-check fa-3x"></i>
                              </button>
                              <p>
                                CHEGADA<small></small>
                              </p>
                            </li>
                          </>
                        )}
                      </>}

                  </ul>
                </div>
              </div>
            </>
          );
        })}
      </PageHeader>
    </>
  );
};

ProcessTimeLine.propTypes = { dadosProcesso: PropTypes.object, operacao: PropTypes.string.isRequired };

export default ProcessTimeLine;
